// extracted by mini-css-extract-plugin
module.exports = {"clearButton":"CloseButton_clearButton__1rlHx"};